import React from "react";
import { motion } from "motion/react";
import PropTypes from "prop-types";

/**
 * Affiche les liens GitHub et/ou Visiter pour une réalisation web
 * @param {string} git - URL du dépôt GitHub
 * @param {string} link - URL du site
 */

const iconVariants = {
  rest: { rotate: 0 },
  hover: { rotate: 360, transition: { duration: 0.4 } },
};

const AnimatedIcon = ({ type }) => {
  AnimatedIcon.propTypes = {
    type: PropTypes.string.isRequired,
  };
  if (type === "github") {
    return (
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="inline-block w-4 h-4 mr-1"
        variants={iconVariants}>
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
      </motion.svg>
    );
  }
  if (type === "link") {
    return (
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="inline-block w-4 h-4 mr-1"
        variants={iconVariants}>
        <path
          fillRule="evenodd"
          d="M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z"
          clipRule="evenodd"
        />
      </motion.svg>
    );
  }
  return null;
};

function renderAnimatedLink({ href, type, label, extraClass = "" }) {
  return (
    <motion.a
      whileHover="hover"
      href={href}
      rel={type === "github" ? "noreferrer" : "noreferrer noopener"}
      target="_blank"
      className={
        "text-xs px-2 py-1 rounded-md bg-gray-200 hover:bg-gray-100 transition duration-300 ease-in-out " +
        extraClass
      }
      title={type === "github" ? "Voir le dépôt GitHub" : "Voir le site"}>
      <AnimatedIcon type={type} /> {label}
    </motion.a>
  );
}

const ProjectLinks = ({ git, link }) => (
  <>
    {git &&
      renderAnimatedLink({
        href: git,
        type: "github",
        label: "GitHub",
        extraClass: "mr-2",
      })}
    {link &&
      renderAnimatedLink({
        href: link,
        type: "link",
        label: "Visiter",
      })}
  </>
);

ProjectLinks.propTypes = {
  git: PropTypes.string,
  link: PropTypes.string,
};

export default ProjectLinks;
